/**
 * Binary audio protocol constants — duplicated from ci-backend/src/modules/pipeline/constants.ts.
 * Must be kept in sync with backend definitions.
 *
 * Frame format for audio sent to backend (0x01 header):
 *   [0x01][16-byte session UUID][PCM data...]
 *
 * Frame format for TTS received from backend (0x02 header):
 *   [0x02][16-byte segment UUID][4-byte uint32 BE durationMs][1-byte direction][MP3 data...]
 */

export const AUDIO_HEADER = 0x01;
export const TTS_HEADER = 0x02;

export const SESSION_UUID_BYTES = 16;
export const DURATION_BYTES = 4;
export const DIRECTION_BYTES = 1;

/** Total header size for an outbound audio frame: 1 (header) + 16 (UUID) = 17 bytes */
export const AUDIO_HEADER_SIZE = 17;

/**
 * Total header size for an inbound TTS frame:
 * 1 (header) + 16 (UUID) + 4 (durationMs) + 1 (direction) = 22 bytes
 */
export const TTS_HEADER_SIZE = 22;

export const DIRECTION_DOCTOR_TO_PATIENT = 0x01;
export const DIRECTION_PATIENT_TO_DOCTOR = 0x02;
